import React, { useState } from 'react';
import { Award, Crown, Loader2 } from 'lucide-react';
import { apiCall } from './_shared';

const STYLE = {
  gold: { badge: 'bg-amber-100 text-amber-900 border-amber-300', box: 'bg-amber-50 border-amber-200', Icon: Crown },
  silver: { badge: 'bg-slate-200 text-slate-900 border-slate-300', box: 'bg-slate-50 border-slate-200', Icon: Award },
};

// Small inline badge for queue rows.
export const TierBadge = ({ loyalty, testId }) => {
  if (!loyalty) return null;
  const st = STYLE[loyalty.tier] || STYLE.silver;
  const Icon = st.Icon;
  return <span className={`inline-flex items-center gap-0.5 text-[10px] px-1.5 py-0.5 rounded border font-bold uppercase ${st.badge}`} data-testid={testId}><Icon className="w-3 h-3" /> {loyalty.tier}</span>;
};

// Badge + promised-benefits checklist (reception ticks what was delivered).
export const TierPanel = ({ bookingId, loyalty, canEdit, onChanged, testId = 'tier-panel' }) => {
  const [busy, setBusy] = useState(false);
  const [local, setLocal] = useState(null);
  if (!loyalty) return null;
  const st = STYLE[loyalty.tier] || STYLE.silver;
  const Icon = st.Icon;
  const delivered = local || loyalty.delivered || [];
  const toggle = async (b) => {
    if (!canEdit) return;
    const next = delivered.includes(b) ? delivered.filter((x) => x !== b) : [...delivered, b];
    setLocal(next); setBusy(true);
    try { await apiCall(`/api/admin/arrival-desk/${bookingId}/loyalty-delivered`, { method: 'POST', body: JSON.stringify({ delivered: next }) }); onChanged?.(); } catch (e) { alert(e.message); setLocal(null); } finally { setBusy(false); }
  };
  const items = (loyalty.benefits || []).map((b) => (
    <li key={b}>
      <label className={`inline-flex items-start gap-1.5 ${canEdit ? 'cursor-pointer' : ''}`}>
        <input type="checkbox" checked={delivered.includes(b)} onChange={() => toggle(b)} disabled={!canEdit || busy} className="mt-0.5" data-testid={`${testId}-benefit-${(loyalty.benefits || []).indexOf(b)}`} />
        <span className={delivered.includes(b) ? 'line-through text-slate-500' : ''}>{b}</span>
      </label>
    </li>
  ));
  const done = delivered.length, total = (loyalty.benefits || []).length;
  return (
    <div className={`border rounded-lg p-2.5 text-xs ${st.box}`} data-testid={testId}>
      <div className="flex flex-wrap items-center gap-2">
        <span className={`inline-flex items-center gap-1 text-[11px] px-2 py-0.5 rounded border font-bold uppercase ${st.badge}`} data-testid={`${testId}-badge`}><Icon className="w-3.5 h-3.5" /> {loyalty.label}</span>
        <span className="text-slate-700">{loyalty.stays} completed stay{loyalty.stays === 1 ? '' : 's'} · {loyalty.nights} nights · direct code −{loyalty.discount_pct} %</span>
        <span className={`ml-auto text-[11px] font-semibold ${done === total && total ? 'text-emerald-700' : 'text-slate-600'}`} data-testid={`${testId}-progress`}>{busy ? <Loader2 className="w-3 h-3 animate-spin inline" /> : `${done}/${total} perks delivered`}</span>
      </div>
      <p className="text-[11px] text-slate-600 mt-1">Promised to this guest — tick each perk as you deliver it:</p>
      <ul className="mt-1 space-y-0.5">{items}</ul>
      {loyalty.delivered_at && <p className="text-[10px] text-slate-500 mt-1">last update {loyalty.delivered_at.slice(0, 16).replace('T', ' ')} by {loyalty.delivered_by}</p>}
    </div>
  );
};

export default TierPanel;
